import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { SubSink } from 'subsink';
import { Tip } from '@model';
import * as fromAppStore from '@appStore/app';
import { Sidebar } from '@enums';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
    selector: 'app-tips',
    templateUrl: './tips.component.html',
    standalone: false
})
  export class TipsComponent implements OnInit, OnDestroy {
    @Input()
    tips: Tip[];

    private subs = new SubSink();
    isUnreadOnly = true;
    filteredTips: Tip[] = [];

    constructor(
        private router: Router,
        private appStore: Store<fromAppStore.State>
        ){}

    ngOnInit(): void {
        this.setFilteredTips();
    }

    ngOnChanges(): void{
        this.setFilteredTips();
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    onUnreadChange(args: MatSlideToggleChange){
        this.setFilteredTips();
    }

    onClose(): void{
        this.appStore.dispatch(new fromAppStore.TipsClose());
        this.appStore.dispatch(new fromAppStore.InactivateSidebar(Sidebar.Tips));
    }

    onNavigate(tip: Tip){
        this.onClose();
        this.router.navigate([ tip.url ]);
    }

    onHide(tip: Tip){
        this.appStore.dispatch(new fromAppStore.TipSetAsRead(tip));
    }
    
    private setFilteredTips(){
        this.filteredTips = this.isUnreadOnly ? this.tips.filter(tip => !tip.isRead) : this.tips;
    }

  }
